<template>
  <transition :css="false" :appear="false" @enter="enter" @leave="leave">
    <div class="ShadowSlide">
      <img ref="image" :src="image" />
    </div>
  </transition>
</template>

<script>
import gsap, { TweenMax } from "gsap";

export default {
  props: {
    index: Number,
    product: Object,
    animDirection: String,
    images: Object,
    isCampaign: Boolean,
  },
  computed: {
    image() {
      const { index, product, images, isCampaign } = this;
      if (!isCampaign) {
        return images[product.id];
      }
      const paddedIndex = `${index}`.padStart(2, "0");
      const imageKey = `${paddedIndex}/${product.id}`;
      return images[imageKey];
    },
  },
  methods: {
    enter(el, done) {
      const { animDirection, $refs } = this;
      const x = animDirection == "right" ? "15%" : "-15%";

      gsap.fromTo(
        $refs.image,
        0.5,
        {
          x,
          alpha: 0,
        },
        {
          x: 0,
          alpha: 0.3,
          delay: 0.5,
          ease: "power3.out",
          onComplete: done,
        },
      );
    },
    leave(el, done) {
      const { animDirection, $refs } = this;
      const x = animDirection == "right" ? "-15%" : "15%";

      TweenMax.to($refs.image, 0.5, {
        x,
        alpha: 0,
        ease: "power3.out",
        onComplete: () => {
          gsap.set(el, { clearProps: "all" });
          done();
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './ShadowSlide.styl';
</style>
